import { HourStatsOpenShifts } from '@/data/hourStats/models';
import { HourStatsOpenShiftsState } from '@/data/hourStats/states';
import { DELETE_HOUR_STATS_OPENSHIFTS, FETCH_HOUR_STATS_OPENSHIFTS, RESET_SCHEDULER_STATE } from '@/store/action-types';

import { Map } from 'immutable';

export default (state = new HourStatsOpenShiftsState(), action) => {
  switch (action.type) {
    case FETCH_HOUR_STATS_OPENSHIFTS.REQUEST:
      return state.merge({
        loading: true,
        receivedAt: 0,
      });
    case FETCH_HOUR_STATS_OPENSHIFTS.SUCCESS:
      return state.merge({
        loaded: true,
        loading: false,
        error: null,
        receivedAt: Date.now(),
        items: new Map(
          action.payload.map(hourStats => {
            return [`${hourStats.id}-${hourStats.start}`, new HourStatsOpenShifts(hourStats)];
          }),
        ),
      });
    case FETCH_HOUR_STATS_OPENSHIFTS.FAILURE:
      return state.merge({
        loading: false,
        error: action.payload,
      });
    case DELETE_HOUR_STATS_OPENSHIFTS:
      return state.merge({
        items: state.items.filterNot(hourStats => action.ids.includes(`${hourStats.id}-${hourStats.start}`)),
      });
    case RESET_SCHEDULER_STATE:
      return new HourStatsOpenShiftsState();
    default:
      return state;
  }
};
